import {Alert, Form} from 'antd';
import React, {forwardRef, LegacyRef} from 'react';
import CenteredLoadingScreen from "../../CenteredLoadingScreen";
import VeriflytTicketEditor, {VeriflytTicketEditorApi} from "../../editor/veriflyt-ticket-editor/veriflyt-ticket-editor";

export interface ComplianceEntryFormProps {
    editorApi: VeriflytTicketEditorApi
}

const ComplianceEntryForm: React.FC<ComplianceEntryFormProps> = forwardRef(function ComplianceEntryForm({ editorApi }, ref: LegacyRef<Form>) {

    if (editorApi.loading){
        return <CenteredLoadingScreen />
    }

    const errorMsg = editorApi.error ? (
        <Alert
            style={{ marginBottom: 12 }}
            type="error"
            showIcon={true}
            message="Failed to load compliance data"
        />
    ) : null

    return <Form ref={ref} style={{ padding: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
        {errorMsg}
        <VeriflytTicketEditor
            api={editorApi}
        />
    </Form>
})

export default ComplianceEntryForm